// Text which will be imported in RolesList.js of RolesList
const ROLE_LIST = {
  MANAGE_ROLE_TITLE: "Manage Roles",
  MANAGE_ROLE_SUBTITLE: "You can update your company account information here.",
  PERMISSION_HEADING: "PERMISSIONS",
  ROLES: "ROLES",
};

const USER_ROLES = {
  ADMIN: "Admin",
  USER: "User",
};
export { ROLE_LIST, USER_ROLES };



// WEBPACK FOOTER //
// ./src/constants/roleList.js